import { tasksRepo } from '@/constants/providers';
import { useInvalidateUserQueries } from '@/shared/hooks/useInvalidateUserMutations';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { DisassociateUserModel } from '../types/disassociate-user-model';

export const useDisassociateUser = () => {
  const { t } = useTranslation();
  const invalidateUserQueries = useInvalidateUserQueries();

  return useMutation<void, unknown, DisassociateUserModel>(
    (user) => tasksRepo.disassociateUser(user),
    {
      onError: () => {
        toast.error(t('error_remove_user_from_task'));
      },
      onSuccess: () => {
        invalidateUserQueries();
        toast.success(t('success_remove_user_from_task'));
      },
    },
  );
};
